import { IBlockedUser, IReqBlockedUser } from '@dataTypes/blocked-user.type'
import axios from './axiosConfig'
import { getEnv } from '@utils/env'
import { logger } from '@utils/safeLogger'
import { toApiError } from './errors/api-error'

// Constants
const BUSINESS_LAYER_API = getEnv('REACT_APP_BUSINESS_LAYER_BLOCKED_USER', '')

const headers = {
  'Content-Type': 'application/json',
}

// Types
interface ApiResponse<T> {
  statusCode: number
  message: string
  data: T
}

type BlockedUsersResponseData = {
  blocked_users?: IBlockedUser[]
}

type GenericResponseData = Record<string, unknown>

export type GetAllBlockedUsersResponse = ApiResponse<BlockedUsersResponseData>
export type BlockedUserGenericResponse = ApiResponse<GenericResponseData>

// API Functions
export const getAllBlockedUsers =
  async (): Promise<GetAllBlockedUsersResponse> => {
    try {
      const response = await axios.get<GetAllBlockedUsersResponse>(
        `${BUSINESS_LAYER_API}/api/v1/blocked-user`,
        {
          headers,
        },
      )

      return response.data
    } catch (e: unknown) {
      logger.error('Error in getAllBlockedUsers:', e)
      throw toApiError(e, 'An unknown error occurred')
    }
  }

export const createBlockedUser = async (
  blockedUserDetails: IReqBlockedUser,
): Promise<BlockedUserGenericResponse> => {
  try {
    const response = await axios.post<BlockedUserGenericResponse>(
      `${BUSINESS_LAYER_API}/api/v1/blocked-user`,
      blockedUserDetails,
      {
        headers,
      },
    )

    return response.data
  } catch (e: unknown) {
    logger.error('Error in createBlockedUser:', e)
    throw toApiError(e, 'An unknown error occurred')
  }
}

export const updateBlockedUserById = async (
  blocked_user_id: string,
  data: Partial<IReqBlockedUser>,
): Promise<BlockedUserGenericResponse> => {
  try {
    const response = await axios.put<BlockedUserGenericResponse>(
      `${BUSINESS_LAYER_API}/api/v1/blocked-user`,
      {
        blocked_user_id,
        data,
      },
      {
        headers,
      },
    )

    return response.data
  } catch (e: unknown) {
    logger.error('Error in createBlockedUser:', e)
    throw toApiError(e, 'An unknown error occurred')
  }
}

export const deleteBlockedUser = async (
  blocked_user_id: string,
): Promise<BlockedUserGenericResponse> => {
  try {
    const response = await axios.delete<BlockedUserGenericResponse>(
      `${BUSINESS_LAYER_API}/api/v1/blocked-user/${blocked_user_id}`,
      {
        headers,
      },
    )

    return response.data
  } catch (e: unknown) {
    logger.error('Error in deleteBlockedUser:', e)
    throw toApiError(e, 'An unknown error occurred')
  }
}
